import ReactDevTabs from 'react-dev-tabs';

import { allowDevTools } from 'utils/config';

const DevTabs = () => {
  if (!allowDevTools) {
    return null;
  }
  return (
    <ReactDevTabs
      visible={allowDevTools}
      zIndex={1100}
      tabs={[
        {
          type: 'components',
          label: 'Components',
          modules: () => import('./components'),
        },
        {
          type: 'components',
          label: 'Views',
          modules: () => import('./views'),
        },
        {
          size: 70,
          type: 'assets',
          label: 'Icons',
          path: 'assets',
          modules: () => import('assets/icons/mono'),
        },
        {
          size: 70,
          type: 'assets',
          label: 'Icons Color',
          path: 'assets',
          modules: () => import('assets/icons/color'),
        },
        {
          type: 'assets',
          label: 'Images',
          size: 300,
          path: 'assets',
          modules: () => import('assets/images'),
        },
      ]}
    />
  );
};

export default DevTabs;
